import { useMemo } from 'react';

export const useIsHolidaySeason = (): boolean => {
  return useMemo(() => {
    const now = new Date();
    const month = now.getMonth() + 1; // 1-12
    const day = now.getDate();

    // December (month 12): from day 1 onwards
    if (month === 12) {
      return true;
    }

    // January (month 1): until day 5
    if (month === 1 && day <= 5) {
      return true;
    }

    return false;
  }, []);
};

